import { Link } from "react-router-dom";

export function PartnerUserActionFragment(props) {
  return (
    <div className="flex items-center gap-x-2 justify-center">
      |
      <Link to={props.row.highestQualificationFile.downloadUrl}>
        <button className="btn-link">
          Download Highest Qualification Certificate
        </button>
      </Link>{" "}
      |
      <Link to={props.row.identityProofFile.downloadUrl}>
        <button className="btn-link">Download Identity Proof</button>
      </Link>{" "}
      |
      <Link to={props.row.candidatePhotoFile.downloadUrl}>
        <button className="btn-link">Download Candidate Photo</button>
      </Link>{" "}
      |
      <Link to={props.row.candidateSignatureFile.downloadUrl}>
        <button className="btn-link">Download Candidate Signature</button>
      </Link>
    </div>
  );
}
